import type { Laudo } from "./schema";
import { posicoesFaltantes } from "./veiculo-fotos";

type Perfil = { empresaId?: string | null; roles?: string[] | null; ativo?: boolean };

/** Janela em que o Parceiro ainda mexe no laudo e pode pedir o envio ao Técnico de Vistoria. */
export const naJanelaDoParceiro = (status: string): boolean => status === "rascunho" || status === "enviado_analise";

/** Parceiro de negócios da empresa que pediu o laudo: nem a equipe da vistoriadora nem o owner. */
export const ehParceiroDoLaudo = (perfil: Perfil, laudo: { parceiroId: string }): boolean =>
  perfil.ativo !== false && !!perfil.empresaId && perfil.empresaId === laudo.parceiroId && !!perfil.roles?.includes("parceiro_negocios");

/** O que as rotas do envio ao técnico precisam saber de um laudo (a linha leve, sem as relações). */
export type LaudoEnvioTv = Pick<
  Laudo,
  "id" | "laudoId" | "status" | "parceiroId" | "vistoriadoraId" | "tecnicoVistoriaId" | "envioTvSolicitadoEm"
>;

type PedidoDoLaudo = { tecnicoVistoriaId: string | null; envioTvSolicitadoEm?: Date | string | null };

/** O botão "Enviar para o Técnico de Vistoria" do detalhe: Parceiro dono, na janela, sem pedido nem técnico, e só com TV único. */
export const podeEnviarAoTecnico = (
  perfil: Perfil,
  laudo: PedidoDoLaudo & { parceiroId: string; status: string },
  tvUnico: boolean,
): boolean =>
  tvUnico && ehParceiroDoLaudo(perfil, laudo) && naJanelaDoParceiro(laudo.status) && !laudo.tecnicoVistoriaId && !laudo.envioTvSolicitadoEm;

/** Pedido já feito e técnico ainda não atribuído: o que o laudo espera (as 4 fotos do Detran ou a vistoriadora). */
export function esperaDoPedido(
  laudo: PedidoDoLaudo & { moduloDetranVeiculoFoto: boolean },
  fotos: readonly { posicao: string }[],
): "fotos" | "atribuicao" | null {
  if (!laudo.envioTvSolicitadoEm || laudo.tecnicoVistoriaId) return null;
  return laudo.moduloDetranVeiculoFoto && posicoesFaltantes(fotos).length > 0 ? "fotos" : "atribuicao";
}
